module.exports = __webpack_public_path__ + "913aa2e4df85d9d4b75ac7e5893ad073.png";